import NavCreators from '../../Redux/NavRedux';

export default {
  changeSizeSidebar: NavCreators.navSetProp,
};
